// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","userEmployment":"_3xmq7WmNNnJh5heeoCRRWK","anonEmployer":"_201ybn5uFg3aRqvrzRa4w-","anonCity":"Rfyzjx8vC2ozBNXYJAMh7"};